import { api } from "../config/api";

export const postNewLeague = (formData) => api.post(`league`, formData);
